import { ArrowPathIcon } from '@heroicons/react/24/outline';

interface ArtifactLoadingStateProps {
  message?: string;
  variant?: 'default' | 'compact';
}

export const ArtifactLoadingState = ({
  message = 'Loading artifacts...',
  variant = 'default',
}: ArtifactLoadingStateProps) => {
  const isCompact = variant === 'compact';

  return (
    <div
      className={`flex flex-col items-center justify-center text-muted-foreground ${
        isCompact ? 'p-4' : 'h-full w-full p-8'
      }`}
    >
      <ArrowPathIcon
        className={`animate-spin ${isCompact ? 'h-4 w-4' : 'h-5 w-5'}`}
      />
      <p className={`mt-2 ${isCompact ? 'text-xs' : 'text-sm'}`}>{message}</p>
    </div>
  );
};
